/* eslint-disable no-use-before-define */
import React from 'react';
import {
    GuestGuard,
} from '../guards/RolesGuard';
import { UserGuard } from '../guards/UserGuard';
import Layout from '../container/Layout';
import Homepage from '../features/dashboard/homepage';
import Settings from '../features/dashboard/settings';
import AiAuth from '../features/ai-auth/AiAuth';
import AiRegister from '../features/ai-auth/Register';
import SocketConnect from '../components/socket/SocketConnect';
import ChatPage from '../features/chat/ChatPage';
import {
    NoctyraBlogArticlePage,
    NoctyraHotelPage,
} from '../features/noctyra/NoctyraHotelPages';

export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string;
    key?: string;
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    {
        path: '/',
        element: <NoctyraHotelPage />,
    },
    {
        path: '/chat',
        element: <ChatPage />,
    },
    {
        path: '/chat/post/:slug',
        element: <ChatPage />,
    },
    {
        path: '/auth',
        element: <AiAuth />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/admin',
        element: <AiAuth />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/register',
        element: <AiRegister />,
        key: 'guest',
        guard: GuestGuard,
    },
	{
        path: '/socket',
        element: <SocketConnect />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/dashboard',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage />
            },
        ]
    },
    {
        path: '/dashboard/:agent/widget-customisation',
        element: <Layout />,
        key: 'admin-widget-customisation',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: (
                    <Homepage initialSection="widget-customisation" />
                ),
            },
        ],
    },
    {
        path: '/dashboard/:agent/widget-installation',
        element: <Layout />,
        key: 'admin-widget-installation',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: (
                    <Homepage initialSection="widget-installation" />
                ),
            },
        ],
    },
    {
        path: '/dashboard/:agent/account-settings',
        element: <Layout />,
        key: 'admin-account-settings',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage initialSection="account-settings" />,
            },
        ],
    },
    {
        path: '/dashboard/:agent/ai-agents',
        element: <Layout />,
        key: 'admin-ai-agents',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage initialSection="ai-agents" />,
            },
        ],
    },
    {
        path: '/dashboard/:agent/billing',
        element: <Layout />,
        key: 'admin-billing',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage initialSection="billing" />,
            },
        ],
    },
    {
        path: '/dashboard/:agent',
        element: <Layout />,
        key: 'admin-widget-customisation-default',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage initialSection="widget-customisation" />,
            },
        ],
    },
    {
        path: '/insights',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage />,
            },
        ],
    },
    {
        path: '/insight',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage initialSection="widget-customisation" />,
            },
        ],
    },
    {
        path: '/widget-customisation',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Homepage initialSection="widget-customisation" />,
            },
        ],
    },
    {
        path: '/settings',
        element: <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Settings />
            }
        ]
    },
    {
        path: '/noctyra-hotels',
        element: <NoctyraHotelPage />,
    },
    {
        path: '/noctyra-hotels/blog/us-open-this-august-in-new-york',
        element: <NoctyraBlogArticlePage />,
    },
];
